// DEV | STAG
// export let apiUrl = "http://127.0.0.1:8000/api/bot/";
// export let eventApiKey = "testingapikey";
// export let eventApiUrl =
//   "http://fireanalytics.fireanalytics-staging.staging-k8.wrkind.com/";
// export let s3initialurl = "https://resources.workindia.in/";

// PROD
export let apiUrl = "https://api.workindia.in/api/bot/";
export let s3initialurl = "https://resources.workindia.in/";
export let eventApiKey = "ll4bYK0uZj71gFMQLcoEgvYBWIFY8qd4HYukALm0";
export let eventApiUrl = "https://fireanalytics.workindia.in/";
export let s3PresignedUrlGen = "https://9nbxw8kxb0.execute-api.ap-south-1.amazonaws.com/generic_s3_presigned_url_generator_1";